<section class="mu-home font-size-14" *ngIf="activityDetailsForm">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <form [formGroup]="activityDetailsForm">
            <div class="row">
              <div class="col-md-12 text-end">
                <button
                  *ngIf="canShowNewJoineeWorkflowButton"
                  type="button"
                  class="btn-actvtytp me-1"
                  (click)="goToNewJoineeWorkflow()"
                >
                  Go to Workflow
                </button>

                <a>
                  <button type="button" class="btn-actvtytp" (click)="downloadActivity()">DOWNLOAD</button>
                </a>
              </div>
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3 class="mb-0">View/Update Activity Details</h3>
              </div>
              <div class="row row-cols-6">
                <div class="col-md-6 col-12">
                  <div class="row p-2">
                    <div class="col-4">Activity ID</div>
                    <div class="col">{{ f.displayId.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Activity Name</div>
                    <div class="col">{{ f.name.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Category</div>
                    <div class="col">{{ this.activity?.taskCategory }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Type of Activity</div>
                    <div class="col">{{ f.type.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Description</div>
                    <div class="col" style="white-space: pre-line; word-break: break-all">
                      {{ f.description.value }}
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Request Initiated On</div>
                    <div class="col">{{ f.createdDatetime.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Detailed Status</div>
                    <div class="col">{{ f.detailedStatus.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Current Status</div>
                    <div class="col">{{ statusLabel }}</div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="col-12">
                    <app-comment
                      [comments]="activity?.comments"
                      [disableAddComment]="!isActivityUnlocked"
                      (add)="addComment($event)"
                      (notifyChange)="getIfNotifySelected($event)"
                    >
                    </app-comment>
                  </div>
                  <div class="col-12" *ngIf="isActivityUnlocked">
                    <p class="side-panel-label">Upload Documents</p>
                    <app-multiple-file-selector
                      (chooseFiles)="handleFileInput($event)"
                      (removeFiles)="clearSelectedFiles($event)"
                    >
                    </app-multiple-file-selector>
                  </div>
                  <div class="col-12">
                    <div class="p-2">
                      <app-attachment-list
                        [referenceId]="id"
                        [canDownloadAll]="true"
                        [attachments]="activity?.documents"
                        [companyEntityId]="activity?.companyEntityId"
                        [canDelete]="!(activity?.status === 'COMPLETED' && activity?.name === 'New Joinee Workflow')"
                      >
                      </app-attachment-list>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                <a>
                  <button type="button" class="btn" (click)="updateActivity()" *ngIf="isActivityUnlocked">
                    SAVE & EXIT
                  </button>
                </a>
                <a>
                  <button type="button" class="btn-discard" [routerLink]="ACTIVITY_DASHBOARD_LINK">EXIT</button>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
